import { render } from "./TreeComponent.vue?vue&type=template&id=be716376&scoped=true"
import script from "./TreeComponent.vue?vue&type=script&lang=js"
export * from "./TreeComponent.vue?vue&type=script&lang=js"

import "./TreeComponent.vue?vue&type=style&index=0&id=be716376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be716376"]])

export default __exports__